import ViewerJs from 'viewerjs'

import {
  EVENT_ZOOM,
  EVENT_ZOOMED,
} from 'viewerjs/src/js/constants';
import {
  addListener,
  dispatchEvent,
  isFunction,
  isNumber,
  getOffset,
  getPointersCenter
} from 'viewerjs/src/js/utilities';

export default class Viewer extends ViewerJs {
  first = true;
  constructor(element, options = {
    transition: false
  }) {
    super(element, options)
  }

  initImage(done) {
    super.initImage(done)
    if (this.$zoomTo && this.$originalEvent) {
      setTimeout(() => {
        this.zoomOverride(this.$zoomTo, true, this.$originalEvent)
      }, 10)
    } else if (this.$zoomTo) {
      setTimeout(() => {
        this.zoomOverride(this.$zoomTo, true)
      }, 10)
    }
  }

  showOverride(immediate, options) {

    if (options) {
      this.$zoomTo = options.zoomTo
      this.$originalEvent = options.originalEvent
    }
    super.show(immediate)
  }

  zoomOverride(ratio) {
    var hasTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _originalEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var imageData = this.imageData;

    ratio = Number(ratio);

    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }

    if (this.first) {
      if (imageData.naturalWidth >= imageData.naturalHeight) {
        this.zoomToOverride(screen.height / imageData.naturalHeight, hasTooltip, _originalEvent);
      } else {
        this.zoomToOverride(screen.width / imageData.naturalWidth, hasTooltip, _originalEvent);
      }
      this.first = false;
    } else {
      this.zoomToOverride(imageData.width * ratio / imageData.naturalWidth, hasTooltip, _originalEvent);
    }
    return this;
  }

  zoomToOverride(ratio) {
    var hasTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _this2 = this;

    var _originalEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var _zoomable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var element = this.element,
      options = this.options,
      pointers = this.pointers,
      imageData = this.imageData;


    ratio = Math.max(0, ratio);
    if (isNumber(ratio) && !this.played && (_zoomable || options.zoomable)) {
      // if (isNumber(ratio) && this.viewed && !this.played && (_zoomable || options.zoomable)) {
      if (!_zoomable) {
        var minZoomRatio = Math.max(0.01, options.minZoomRatio);
        var maxZoomRatio = Math.min(100, options.maxZoomRatio);

        ratio = Math.min(Math.max(ratio, minZoomRatio), maxZoomRatio);
      }

      // if (_originalEvent && ratio > 0.95 && ratio < 1.05) {
      //   ratio = 1;
      // }

      var newWidth = imageData.naturalWidth * ratio;
      var newHeight = imageData.naturalHeight * ratio;
      var oldRatio = imageData.width / imageData.naturalWidth;
      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom, {
          once: true
        });
      }

      if (dispatchEvent(element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: oldRatio,
          originalEvent: _originalEvent
        }) === false) {
        return this;
      }

      this.zooming = true;

      if (_originalEvent) {
        var offset = getOffset(this.viewer);
        var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        };

        if (this.first) {
          if (imageData.width >= imageData.height) {
            imageData.left -= (newWidth - imageData.width) * ((center.pageX - offset.left - imageData.left) / imageData.width);
            imageData.top -= (newHeight - imageData.height) / 2;
            if (imageData.left > 0) {
              imageData.left = 0
            } else if ((newWidth - screen.width) < Math.abs(imageData.left)) {
              imageData.left = -newWidth + screen.width
            }
          } else {
            imageData.left -= (newWidth - imageData.width) / 2;
            imageData.top -= (newHeight - imageData.height) / 2;
          }
        } else {
          imageData.left -= (newWidth - imageData.width) * ((center.pageX - offset.left - imageData.left) / imageData.width);
          imageData.top -= (newHeight - imageData.height) * ((center.pageY - offset.top - imageData.top) / imageData.height);
        }

      } else {
        // Zoom from the center of the image
        imageData.left -= (newWidth - imageData.width) / 2;
        imageData.top -= (newHeight - imageData.height) / 2;
      }
      
      imageData.width = newWidth;
      imageData.height = newHeight;
      imageData.ratio = ratio;

      this.renderImage(function () {
        _this2.zooming = false;

        if (isFunction(options.zoomed)) {
          addListener(element, EVENT_ZOOMED, options.zoomed, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_ZOOMED, {
          ratio: ratio,
          oldRatio: oldRatio,
          originalEvent: _originalEvent
        });
      });

      if (hasTooltip) {
        this.tooltip();
      }
    }
    return this;
  }

}